import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import forms from 'constants/forms';
import Input from 'components/atoms/input';

const ContactInfo = ({ errors }) => {
  const contactInfo = [...forms.adminPanelsUser.userAdd.contactInfo];
  return (
    <div className="admin-patient-form-block">
      <span>Contact Info</span>
      <Row>
        {contactInfo.map((field) => (
          <Col lg="6" md="6" sm="6" xs="12" key={field.id}>
            <Input {...field} dataCy="timezone-input" />
            {errors[field.id] ? (
              <div className="input-error">{errors[field.id]}</div>
            ) : null}
          </Col>
        ))}
      </Row>
    </div>
  );
};

ContactInfo.propTypes = {
  errors: PropTypes.shape(),
};

export default ContactInfo;
